import { Auth0ContextInterface, LogoutOptions, useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import { useCallback, useContext } from 'react';
import { UserResponse } from 'cmp-client-api';
import {
  ApplicationConfigurationKeyEnum,
  ApplicationConfigurationService,
} from '@src/core/application-configuration';
import { TokenProviderContext } from '@src/core/auth/components/token-provider.component';
import { SCU } from '@src/core/auth/components/types/accessToken';

interface AuthHookInterface extends Omit<Auth0ContextInterface, 'user' | 'logout'> {
  user: UserResponse;
  scus: SCU[];
  rawAccessToken?: string;
  logout: (options?: Partial<LogoutOptions>) => Promise<void>;
}

const useAuth = (): AuthHookInterface => {
  const { logout: auth0Logout, ...rest } = useAuth0();

  const { user, rawAccessToken, scus } = useContext(TokenProviderContext) || {};

  const logoutCIAM = useCallback(async () => {
    const ciamLogoutUrl = ApplicationConfigurationService.getValue(
      ApplicationConfigurationKeyEnum.globalLogoutUrl
    ) as string;

    await axios
      .post(ciamLogoutUrl, undefined, {
        withCredentials: true,
      })
      .catch(() => {});
  }, []);

  const logout = useCallback(
    async (options) => {
      await logoutCIAM();
      auth0Logout({
        returnTo: window.location.origin,
        ...options,
      });
    },
    [logoutCIAM, auth0Logout]
  );

  return {
    ...rest,
    rawAccessToken,
    user,
    logout,
    scus,
  };
};

export default useAuth;
